import { Component, Input } from "@angular/core";
import { MenuItem } from "primeng/api";
import { ContextMenuService } from "src/app/services/shared/context-menu-service";
import { FilterOption } from "../datatable/datatablecolumn/datatablecolumn.component";
import { faPaperclip } from "@fortawesome/free-solid-svg-icons";

@Component({
    standalone: false,
    selector: "attachment-menu",
    templateUrl: "./attachment-menu.component.html",
})
export class AttachmentMenu {
    faPaperclip = faPaperclip;
    @Input() itemIndex: number = 0;
    @Input() attachments: FilterOption[] = [];
    @Input() datasetLength: number = 0;
    @Input() item: {} = {};

    private contextMenuService: ContextMenuService;

    constructor(contextMenuService: ContextMenuService) {
        this.contextMenuService = contextMenuService;
    }

    toggleContextMenu(event: MouseEvent) {
        event.preventDefault();
        event.stopPropagation();

        let copiedEvent = this.copyEvent(event);

        let newEvent = new MouseEvent(event.type, copiedEvent);

        this.contextMenuService.show(
            newEvent,
            this.convertOptions(this.attachments)
        );

        return false;
    }

    convertOptions(options: FilterOption[]): MenuItem[] {
        return options.map((option) => {
            return {
                label: option.label,
                target: "_blank",
                url: this.getColumnHref(option.value),
            };
        });
    }

    getColumnHref(url) {
        var urlReplaced = url
            .replace("%", "%25")
            .replace("+", "%2B")
            .replace("#", "%23");

        return urlReplaced;
    }

    close() {
        this.contextMenuService.close();
    }

    private getParentOffsetLeft(target: any): number {
        let offsetLeft = target ? (target.offsetLeft - (target.scrollLeft || 0)) : 0;

        if (target.offsetParent)
            offsetLeft += this.getParentOffsetLeft(target.offsetParent);

        return offsetLeft;
    }

    private copyEvent(event: MouseEvent) {
        let newX = event.clientX;
        let newY = event.clientY;
        let target = event.currentTarget as HTMLButtonElement;
        let parentLeft = (event.target as any)?.offsetParent?.offsetLeft ?? 0;

        parentLeft = this.getParentOffsetLeft(target.offsetParent);

        if (parentLeft > window.innerWidth) parentLeft = window.innerWidth - 75;

        let targetRightEdge =
            parentLeft + target.offsetLeft + target.clientWidth;

        if (window.innerWidth - 175 < targetRightEdge)
            newX =
                targetRightEdge - 175 - target.clientWidth - target.offsetLeft;
        else newX = targetRightEdge + 5;

        let obj = {
            AT_TARGET: event.AT_TARGET,
            BUBBLING_PHASE: event.BUBBLING_PHASE,
            CAPTURING_PHASE: event.CAPTURING_PHASE,
            NONE: event.NONE,
            altKey: event.altKey,
            bubbles: event.bubbles,
            button: event.button,
            buttons: event.buttons,
            cancelBubble: event.cancelBubble,
            cancelable: event.cancelable,
            clientX: newX,
            clientY: newY,
            composed: event.composed,
            ctrlKey: event.ctrlKey,
            currentTarget: event.currentTarget,
            defaultPrevented: event.defaultPrevented,
            detail: event.detail,
            eventPhase: event.eventPhase,
            isTrusted: event.isTrusted,
            metaKey: event.metaKey,
            movementX: event.movementX,
            movementY: event.movementY,
            offsetX: event.offsetX,
            offsetY: event.offsetY,
            pageX: event.pageX,
            pageY: event.pageY,
            relatedTarget: event.relatedTarget,
            returnValue: event.returnValue,
            screenX: event.screenX,
            screenY: event.screenY,
            shiftKey: event.shiftKey,
            srcElement: event.srcElement,
            target: event.target,
            timeStamp: event.timeStamp,
            type: event.type,
            view: event.view,
            which: event.which,
            x: event.x,
            y: event.y,
        };

        return obj;
    }
}
